import React  from 'react';
import { Link, NavLink } from 'react-router-dom'
import { getImgUrl, limitText, isMobile } from "../../Utility/Utility"
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import Deals from '../Deals/Deals';
import YouTube from 'react-youtube';
import "./UI.css"


export const Input = ( props ) => {
  let name =  props.name;
  let labelProp =  props.label;

  let cssWrapperClass = 'form-input-wrapper input-' +  name + '-wrapper ' + props.inputCssClass;
  let cssInputClass = ' input-'+name +' '  ;
  let labelField  = '';
  let id = "ac-input-" + new Date().getTime();
  
  if ( labelProp !== undefined ) {
    cssWrapperClass += ' inputHasLabel '
    labelField = <label htmlFor={id}> {props.label} </label>
  }
  let  html =  <div className={cssWrapperClass} >
                {labelField}
                <input id={id} data-validation-type={props.validationType} onClick={props.click} onChange={props.change} type={props.type} name={name} className={cssInputClass} placeholder={props.placeholder} value={props.val}/>
              </div>
  if ( props.type === "hidden" ) {
    html =  <input  type={props.type} name={name} className={cssInputClass} placeholder={props.placeholder} value={props.val}/>
  }
  return (  html   );
};

export const Select =  ( props ) => {
  let name = props.name;
  let cssWrapperClass = 'form-input-wrapper input-' +  name + '-wrapper select-' +  name + '-wrapper' + props.cssClass;
  let cssInputClass = 'select-'+name +' '  ;
  let labelProp = props.label;
  let labelField  = '';
  let id = "ac-input-" + new Date().getTime();
  
  if ( labelProp !== undefined ) {
    cssWrapperClass += ' inputHasLabel '
    labelField = <label htmlFor={id}> {props.label} </label>
  }
  return (
    <div className={cssWrapperClass}>
      {labelField}
      <select onChange={props.change} name={props.name} className={cssInputClass}>
       {props.children};
      </select>
    </div>
  )
}

export const TopPart = (props) => {
  return(
    <header className="App-header alignCenter">
        <div className="container">
          <h1 className="App-title">{props.title}</h1>
            <p>
              {props.text}
            </p>
        </div>
    </header>
  )
}

export const Img = (props) => {

  const windowW = window.innerWidth; 

  let desktopImg = ( props.desktopImg ) ?  getImgUrl() + "" + props.desktopImg : "" ;
  let mobileImg = ( props.mobileImg )   ?  getImgUrl() + "" + props.mobileImg : "" ;
  let html = 
    <div className="img-wrapper">
      <img src={desktopImg} alt=""/>
    </div>

  if ( props.mobileImg != undefined ) {
    if ( windowW < 1000 ) {
      html = 
          <div className="img-wrapper">
            <img className="show-on-mobile" src={mobileImg} alt=""/>
          </div>

    }
  }
  return (html)
}

const Btn =(props) => {
  
  const cssClass = (props.cssClass) ? 'ac-btn ' + props.cssClass : props.cssClass;

  return(
    <button className={cssClass} onClick={props.onClick} >
      {props.children}
    </button>
    )
}

export const Logo = () => {
  return(
    <div className="logoWrapper">
      <Img desktopImg={"logo.png"}   />
    </div>
  )
}


export const  HomeTitle = (props) =>{ 
  const cssClass =  'home-title-wrapper ' + props.cssClass;
  return(
    <div className={cssClass} >
      <h2>
        {props.children}
      </h2>
      <div className="title-border"></div>
    </div>
  )
}

export const  WeatherIcon = (props) =>{ 
  let p  =  <p>{props.temp}<sup>o</sup>C</p>;
  let imgPath = "WeatherIcon.png";
  let weatherClass = 'weather-icon-wrapper';
  if ( props.temp === "4H50" ) {
    p = <p>{props.temp}</p>
    imgPath = "WeatherIcon2.png";
    weatherClass = 'weather-icon-wrapper flight-icon-wrapper';
  }
  return(
    <div className={weatherClass}>
      <Img desktopImg={imgPath} />
      <h3>{props.label}</h3>
      {p}
    </div>
  )
}

export const ResponsiveYouTubeIframe =(props)=>{ 


  // const videoSrc = 'https://www.youtube.com/embed/'+props.vidId+'/?autoplay=1&mute=1&rel=0&loop=1&playlist=' + props.vidId;
  
  const youTubeOptions = {

    playerVars: { // https://developers.google.com/youtube/player_parameters
      'autoplay': 1,
      'muted':1,
      'controls':1,
      'loopPlaylists':true,
      'loop':1,
      'playlist':props.vidId
    }
  };
  
  return(
    <div className="responisve-iframe">
    

        <YouTube
                videoId={props.vidId}
                opts={youTubeOptions}
                onReady= {(event) => {
                  event.target.mute();
                  event.target.playVideo();
                }}
              />

    </div>
  )

}

export const VideoSliderItem2 =  (props) => {

   const youTubeOptions = {

    playerVars: { // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      muted:1
    }
  };


  const desc = (props.desc != undefined) ? props.desc : "";
  const doBlank = (props.doBlank != undefined) ? props.doBlank : "";
  const title =  (props.title != undefined) ? limitText(props.title , 30) : "";
  const mobileId =  (props.mobileId != '') ? props.mobileId : "";
  const cssClass =  'cites-slider video-slider-item ' + props.cssClass;

  // console.log('props.mobileId' , props.mobileId);
  // alert(mobileId);
  let target = '';
  if (doBlank){
    target = '_blank';
  }


  let  html = 
   <div className={cssClass}> 
      <div className="inner">
      <Link to={props.link}  target={target} className="read-more-link" />
        <div className="video-img-wrapper" onClick={props.click} >
          <Img desktopImg={props.img} /> 
          <div className="video-play-img-wrapper">
            <Img desktopImg={"Videos/play.png"} /> 
          </div>
        </div>
        <div className="title-wrapper">
          <h3>
            {title}
          </h3>
        </div>


        <div className="desc-wrapper">
          
          <p>
             {limitText( desc) }
          </p>

        </div>
        
        <div className="book-now-wrappr">
          <a href={props.link} target={target} >
            READ MORE >>  
          </a> 
        </div>
      </div>
    </div>


  if  ( isMobile() ) {
    // console.log('mobileId' , mobileId);
    var ht = null;
    if ( mobileId != "" ) {
      ht =  <div className="ac-make-vid-responsive">
          <YouTube
                videoId={mobileId}
                opts={youTubeOptions}
                onReady= {(event) => {
                  event.target.mute();
                  event.target.playVideo();
                }}
              />
          </div>
    }else {
      ht = 
        <div>
         <Img desktopImg={props.img} /> 
          <div className="video-play-img-wrapper">
            <Img desktopImg={"Videos/play.png"} /> 
          </div>
        </div>
    }

    // alert('s');
    html = 
     <div className={cssClass}> 
        <div className="inner">
        
          <div className="video-img-wrapper" onClick={props.clickMobile} >
            {ht}
          </div>
          <div className="title-wrapper">
            <h3>
              {title}
            </h3>
          </div>


          <div className="desc-wrapper">
            
            <p>
               {limitText( desc) }
            </p>

          </div>
          
          <div className="book-now-wrappr">
            <a href={props.link} target={target} >
              READ MORE >>  
            </a> 
          </div>
        </div>
      </div>
  }
  return (html )
}



export const VideoSliderItem3 =  (props) => {
  const desc = (props.desc != undefined) ? props.desc : "";
  const cssClass =  'cites-slider concert-slider-item' + props.cssClass;

  const doBlank = (props.doBlank != undefined) ? props.doBlank : "";


  let target = '';
  if (doBlank){
    target = '_blank';
  }
  return (
        <div className={cssClass}> 
        {/* <Link to={props.link} target={target} className="read-more-link" /> */}
          <div className="concert-img-wrapper" onClick={props.click} >
            <Img desktopImg={props.img} /> 
            <div className="video-play-img-wrapper">
              <Img desktopImg={"Videos/play.png"} /> 
            </div>
          </div>
          <div className="title-wrapper">
            <h3>
              {props.title}
            </h3>
          </div>


         <div className="desc-wrapper">
            
            <p>
               {limitText(desc)}
            </p>

          </div>
          
          <div className="book-now-wrappr">
            <a href={props.link} target={target}>
              READ MORE >>  
            </a> 
          </div>

        </div>
  )

  //  let youTubeOptions = {

  //   playerVars: { // https://developers.google.com/youtube/player_parameters
  //     autoplay: 1,
  //     muted:1
  //   }
  // };


  // const desc = (props.desc != undefined) ? props.desc : "";
  // const doBlank = (props.doBlank != undefined) ? props.doBlank : "";
  // const title =  (props.title != undefined) ? limitText(props.title , 30) : "";
  // const desktopId =  (props.desktopId != '') ? props.desktopId : "";
  // const mobileId =  (props.mobileId != '') ? props.mobileId : "";
  // const cssClass =  'cites-slider video-slider-item ' + props.cssClass;

  // if ( mobileId != "" ) {
  //   youTubeOptions.playerVars.autoplay = 0;
  // }
  // // console.log('props.mobileId' , props.mobileId);
  // // alert(mobileId);
  // let target = '';
  // if (doBlank){
  //   target = '_blank';
  // }


  // let  html = 
  //  <div className={cssClass}> 
  //     <div className="inner">
  //     <Link to={props.link}  target={target} className="read-more-link" />
  //       <div className="video-img-wrapper" onClick={props.click} >
  //         <div className="ac-make-vid-responsive">
  //         <YouTube
  //               videoId={desktopId}
  //               opts={youTubeOptions}
  //               onReady= {(event) => {
  //                 event.target.mute();
  //                 event.target.stopVideo();
  //               }}
  //             />
  //         </div>
  //         <div className={"ac-overlay"}></div>
  //       </div>
  //       <div className="title-wrapper">
  //         <h3>
  //           {title}
  //         </h3>
  //       </div>


  //       <div className="desc-wrapper">
          
  //         <p>
  //            {limitText( desc) }
  //         </p>

  //       </div>
        
  //       <div className="book-now-wrappr">
  //         <a href={props.link} target={target} >
  //           READ MORE >>  
  //         </a> 
  //       </div>
  //     </div>
  //   </div>


  // if  ( isMobile() ) {
  //   // console.log('mobileId' , mobileId);
  //   var ht = null;
  //   if ( mobileId != "" ) {
  //     ht =  <div className="ac-make-vid-responsive">
  //         <YouTube
  //               videoId={mobileId}
  //               opts={youTubeOptions}
  //               onReady= {(event) => {
  //                 event.target.mute();
  //                 event.target.playVideo();
  //               }}
  //             />
  //         </div>
  //   }else {
  //     ht = 
  //       <div>
  //        <Img desktopImg={props.img} /> 
  //         <div className="video-play-img-wrapper">
  //           <Img desktopImg={"Videos/play.png"} /> 
  //         </div>
  //       </div>
  //   }

  //   // alert('s');
  //   html = 
  //    <div className={cssClass}> 
  //       <div className="inner">
        
  //         <div className="video-img-wrapper" onClick={props.clickMobile} >
  //           {ht}
  //         </div>
  //         <div className="title-wrapper">
  //           <h3>
  //             {title}
  //           </h3>
  //         </div>


  //         <div className="desc-wrapper">
            
  //           <p>
  //              {limitText( desc) }
  //           </p>

  //         </div>
          
  //         <div className="book-now-wrappr">
  //           <a href={props.link} target={target} >
  //             READ MORE >>  
  //           </a> 
  //         </div>
  //       </div>
  //     </div>
  // }
  // return (html )
}


export const VideoSliderItem =  (props) => {
  const desc = (props.desc != undefined) ? props.desc : "";
  const cssClass =  'cites-slider video-slider-item ' + props.cssClass;
  const doBlank = (props.doBlank != undefined) ? props.doBlank : "";
  let target = '';
  if (doBlank){
    target = '_blank';
  }
  return (
        <div className={cssClass}> 
          <div className="inner">
          <Link to={props.link}   target={target}  className="read-more-link" />
            <div className="video-img-wrapper" onClick={props.click} >
              <Img desktopImg={props.img} /> 
              <div className="video-play-img-wrapper">
                <Img desktopImg={"Videos/play.png"} /> 
              </div>
            </div>
            <div className="title-wrapper">
             <a href={props.link} target={target} > <h3>
                {limitText(props.title , 50)}
              </h3>
              </a> 
            </div>


            <div className="desc-wrapper">
              
              <p>
                 {limitText( desc) }
              </p>

            </div>
            
            <div className="book-now-wrappr">
              <a href={props.link} target={target} >
                READ MORE >>  
              </a> 
            </div>
          </div>
        </div>
  )
}

export const ConcertSliderItem =  (props) => {
  const desc = props.desc;
  let cssClass =  'cites-slider concert-slider-item ' + props.cssClass;
  if ( props.isTodayBigger === true ) {
      cssClass += ' ac-disabled addOpacity ';
  }
  const doBlank = (props.doBlank != undefined) ? props.doBlank : "";
  
 
  let target = '';
  if (doBlank){
    target = '_blank';
  }
  return (
        <div className={cssClass}> 
          <Link to={props.link} target={target} className="read-more-link" />
          <div className="concert-img-wrapper" onClick={props.click} >

            <Img desktopImg={props.img} /> 
            <div className="video-play-img-wrapper">
              <Img desktopImg={"Videos/play.png"} /> 
            </div>            
          </div>
          <div className="title-wrapper">
            <h3>
              {props.title}
            </h3>
          </div>


          <div className="desc-wrapper">
            
            <p>
               {limitText(props.desc)}
            </p>

          </div>
          
          <div className="book-now-wrappr">
            <a href={props.link}>
              READ MORE >>  
            </a> 
          </div>

        </div>
  )
}

export const PostSliderItem =  (props) => {
  const desc = (props.desc != undefined) ? props.desc : "";
  const cssClass =  'cites-slider concert-slider-item' + props.cssClass;

  const doBlank = (props.doBlank != undefined) ? props.doBlank : "";


  let target = '';
  if (doBlank){
    target = '_blank';
  }
  return (
        <div className={cssClass}> 
        <Link to={props.link} target={target} className="read-more-link" />
          <div className="concert-img-wrapper" onClick={props.click} >
            <Img desktopImg={props.img} /> 
            
          </div>
          <div className="title-wrapper">
            <h3>
              {props.title}
            </h3>
          </div>


         <div className="desc-wrapper">
            
            <p>
               {limitText(desc)}
            </p>

          </div>
          
          <div className="book-now-wrappr">
            <a href={props.link}>
              READ MORE >>  
            </a> 
          </div>

        </div>
  )
}


export const InstagremSliderItem =  (props) => {
  const desc = props.desc;
  const  cssEClass = ( props.cssClass !== undefined ) ?  props.cssClass : '';
  const cssClass =   'cites-slider concert-slider-item ' + cssEClass;

  return (
        <div className={cssClass}> 

          <div className="insta-img-wrapper" onClick={props.click} >
            <Img desktopImg={props.img} /> 
            <div className="insta-icon-wrapper">
              <Img desktopImg={"insta-icon.png"} /> 
            </div>
          </div>
          <div className="title-wrapper">
            <h3>
              @{props.title}
            </h3>
          </div>

          

        </div>
  )
}
export const GallerSideBarItem = (props) => {
  return(
    <div className="cites-slider gallery-slider-item align-center"> 
        <Link to={props.link} className="read-more-link" />
        <div className="gallery-img-wrapper" >
          <Img desktopImg={props.img} /> 
        </div>
        <div className="title-wrapper">
          <h3>
            {props.title}
          </h3>
        </div>
    </div>
  )
}

export const ImgAndText = (props) => {
  const cssClass = 'box col col-50 ' + props.cssClass; 
  return(
      <div className={cssClass}>
        <Link target={'blank'} to={props.link} className="read-more-link" />
        <div className="inner">
         <Img  desktopImg={props.img} mobileImg={props.img_mob}/>
          <div className="link-wrapper">
            <Link to={props.link} target={'_blank'} >
              <h3>
              {props.text}
              </h3>
            </Link>
          </div>
        </div>
      </div>
  )
}


export const FaqItem = (props) => {

  let cssClass = "faq-answer close";
  let cssClass2 = "icon-wrapper closeIcon";

  if ( props.isOpen === true ) {
      cssClass = "faq-answer open"
      cssClass2 = "icon-wrapper openIcon"
  }

  const ht = props.answer;
  return (
    <div className="faq-q-wrapper">
      <div className="faq-q" onClick={props.click}>
        <h3>
          {props.q}
        </h3>  

        <div className={cssClass2}>
          <Img desktopImg={"collpase-icon.jpg"} /> 
        </div>
      </div>
      <div className={cssClass} dangerouslySetInnerHTML={{__html:ht}}>
    
      </div>
    </div>
  )
}



export const HomeDeals = () => {
  return(
    <section className="home-section caruasel-wrapper  home-section-padding" id="deals" >
         <div className="container">
          <HomeTitle>
            <Link to={'/Pages/bestDeals2'} className="ac-book-holiday">  BOOK YOUR HOLIDAY NOW </Link>
          </HomeTitle>
          <Deals />
        </div> 
    </section>
  )
}

export const HomeSlider = (props) => {

  const getParameterByName = function (name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
          results = regex.exec(window.location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  };

  var currentLang = localStorage.getItem('currentLang') != null  ? localStorage.getItem('currentLang') : 'uk';
  var langsArray = [
    'uk',
    'cz',
    'ro',
    'dk',
    'se',
    'hu',
    'nl',
  ];

  // alert(currentLang);

  var l = getParameterByName('lang');

  /// check to see if  in array
  if ( l != '' && langsArray.indexOf(l) !== -1 ) {
    currentLang = l;
  }

  localStorage.setItem('currentLang' , currentLang);


  if ( localStorage.getItem('currentLang') != null ) {
    l =  localStorage.getItem('currentLang');
  }


  
  const bannerSliderSettings = {

        dots: false,
        infinite: true,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        lazyLoad: "ondemand",
        slidesToShow:1,
        slidesToScroll: 1,

    };
  let html =    <SimpleSlider settings={bannerSliderSettings}>
  
                        
                          <div>
                              <Img 
                                 desktopImg={props.coverImg || "HomeSlider/1.jpg"}
                                mobileImg={props.coverImgMobile ||"HomeSlider/M/1.jpg"} 
                              />
                      
                          </div>

                          <div>
                             <Img 
                                 desktopImg={"HomeSlider/2.jpg"}
                                mobileImg={"HomeSlider/M/2.jpg"} 
                              />
                         
                          </div>
                </SimpleSlider>

  const isHomeSlider = (  props.isHomeSlider !== undefined ) ?  props.isHomeSlider : false;

  if ( isHomeSlider === true ) {
    if ( window.innerWidth < 1000 ){
    //   html = <Img mobileImg={'/HomeSlider/M/douze.jpg'} />;
    // }else {
      // html = <div className="ac-responsive-video">
      // <iframe className="ac-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/5PAjhoH0NWU?mute=1&autoplay=1&playlist=5PAjhoH0NWU&rel=0&controls=1&loop=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      //  </div>
    //   html = <Img desktopImg={"/1920-500.jpg"} />;
    // }
      html =    <SimpleSlider settings={bannerSliderSettings}>
                          <div>
                            <Img 
                              mobileImg={"HomeSlider/M/uk/1.jpg"} 
                            />
                          </div>
                          <div>
                            <Img 
                              mobileImg={"HomeSlider/M/uk/2.jpg"} 
                            />
                          </div>

                        </SimpleSlider>

    } else {

         html =   <SimpleSlider settings={bannerSliderSettings}>

                        <div>
                            <Img desktopImg={"HomeSlider/desktop/uk/1.jpg"} />
                        </div>

                       <div>
                            <Img desktopImg={"HomeSlider/desktop/uk/2.jpg"} />
                        </div>

                       {/*  <div>
                            <Img desktopImg={"HomeSlider/desktop/uk/3.jpg"} />
                        </div>
                        <div>
                            <Img desktopImg={"HomeSlider/desktop/uk/4.jpg"} />
                        </div>
                       
                        <div>
                          <Img desktopImg={"HomeSlider/desktop/uk/5.jpg"} />
                        </div>
                        <div>
                          <Img desktopImg={"HomeSlider/desktop/uk/6.jpg"} />
                        </div>*/}
                      

                  </SimpleSlider>

      }
  } else {
       if ( window.innerWidth < 1000 ){

        html =    <SimpleSlider settings={bannerSliderSettings}>
                          <div>
                            <Img mobileImg={"HomeSlider/M/1.jpg"} />
                          </div>
                          <div>
                            <Img mobileImg={"HomeSlider/M/2.jpg"} />
                          </div>

                  </SimpleSlider>

       } else {
            html =    <SimpleSlider settings={bannerSliderSettings}>

                          

                         <div>
                            <Link to={'/Pages/bestDeals2'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/uk/1a.jpg"} 
                              />
                            </Link>
                          </div>

                          {/*<div>
                            <Link to={'/Pages/bestDeals2'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/uk/2a.jpg"} 
                              />
                            </Link>
                          </div>
                       
                         <div>
                            <Link to={'/Pages/bestDeals2'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/uk/3a.jpg"} 
                              />
                            </Link>
                          </div>
                      
                         <div>
                            <Link to={'/Pages/bestDeals2'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/uk/4a.jpg"}
                              />
                            </Link>
                          </div>

                          <div>
                            <Link to={'/Pages/bestDeals2'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/uk/5a.jpg"}
                              />
                            </Link>
                          </div>

                          <div>
                            <Link to={'/Pages/bestDeals2'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/uk/6a.jpg"}
                              />
                            </Link>
                          </div>*/}

                        </SimpleSlider>
       }
  }

  return(
      <section className="home-section caruasel-wrapper banners-caruasel-wrapper" id="part-1" >
          {html}
          <div className="weather-wrapper show-on-mobile">
            <WeatherIcon label={"Water Temp"} temp={props.waterTemp}/>
            <WeatherIcon label={"Tel Aviv"} temp={props.telAvivWeather}/>
            <WeatherIcon label={"Jerusalem"} temp={props.jerusalemWeather}/>
          </div>
        </section>
        
  )
}


export const AnimateCallToAction = (props)=>{
  const cssClass = "hide-on-mobile" + props.cssClass;
  return(
    <a href={props.link} target="_blank" className={cssClass}>
       <Img desktopImg={props.src} />
    </a>
  )
}

export const ActivaImg =(props) =>{

  return(

        <div className="video-img-wrapper" onClick={props.click} >
          <Img desktopImg={props.src} /> 
          <div className="video-play-img-wrapper">
            <Img desktopImg={"Videos/play.png"} className="video-play-ggg"/> 
          </div>
        </div>
  )

}

// export const TravelAlert =(props) =>{

//   return(

//         <section className="home-section home-section-padding" id="travel-alert">
//             <div className="container ac-flex">
              
//               <div className="ac-travel-alert-message col-80">
//                    <p><NavLink  exact to="/Pages/CoronaVirusPage">Travel Alert: Get the latest travel alerts impacting Israel <span>here</span></NavLink></p>
//               </div>
//               <div className="ac-travel-alert-close-wrapper col-20">
//                  <div className="ac-travel-alert-close" onClick={props.click}>
//                      <p>+</p>
//                  </div>
//               </div>
//               <div className="clear"></div>
              
//             </div>
//           </section>
//   )
// }

export const TravelAlert =(props) =>{

  // let placeText1 = 'Travel Alert: Get the latest travel alerts impacting Israel';
  // let linkTo = '/Pages/CoronaVirusPage';
  // let placeText2 = ' here';
  // let placeText3 = '';

  let placeText1 = '';
  let placeText2 = '';
  let placeText3 = '';
  let toLink = '';


  return(

        <section className="home-section home-section-padding" id="travel-alert">


            <div className="container ac-flex">
              
              <div className="ac-travel-alert-message col-80">
                   <p><NavLink  exact to={props.toLink}>{props.placeText1}<span>{props.placeText2}</span>{props.placeText3}</NavLink></p>
              </div>
              <div className="ac-travel-alert-close-wrapper col-20">
                 <div className="ac-travel-alert-close" onClick={props.click}>
                     <p>+</p>
                 </div>
              </div>
              <div className="clear"></div>
              
            </div>
          </section>
  )
}

export const CoverSection = (props) => {
  const desktopImg =  props.desktopImg;
  const mobileImg =  props.mobileImg;
  const cssClass =  props.cssClass;

  return(
    <section className={"ac-cover-section ac-cover-section-"+props.cssClass } id="part-1">
        <Img desktopImg={props.desktopImg} mobileImg={props.mobileImg}/>
        <div className="weather-wrapper show-on-mobile">
            <WeatherIcon label={"WATER TEMP"} temp={props.waterTemp}/>
            <WeatherIcon label={"TEL AVIV"} temp={props.telAvivWeather}/>
            <WeatherIcon label={"JERUSALEM"} temp={props.jerusalemWeather}/>
          </div>
    </section>
  )
}


// WEBPACK FOOTER //
// ./src/Components/UI/UI.js